import { FC, useState } from "react";
import CustomPopup from "../../../custom-components/CustomPopup";
import { useTranslation } from "react-i18next";
import DeleteTrashIconSVG from "../../resources/svg/DeleteTrashIconSVG";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { WorkServiceImpl } from "../../../services/WorkServiceImpl";
import { useNavigate } from "react-router-dom";

interface DeleteWorkProps {
    workId: string;
}

const DeleteWork: FC<DeleteWorkProps> = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const deleteWorkHandler = async () => {
        const result = await dispatch(WorkServiceImpl.deleteWorkByIdThunk({ id: props.workId }));
        if (result.meta.requestStatus === "fulfilled") {
            navigate("/profile");
        }
    };

    return (
        <CustomPopup
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px]"
            confirmTitle={t("common.yes")}
            confirmHandler={deleteWorkHandler}
            confirmButtonClassName="bg-transparent hover:bg-transparent w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mr-8 dmax2:mr-6 mt-8 dmax2:mt-6"
            cancelTitle={t("common.no")}
            cancelButtonClassName="w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
            buttonElement={
                <div
                    className="flex justify-center items-center w-[228px] dmax2:w-[158px] h-[54px] dmax2:h-[42px] rounded-[12px] dmax2:rounded-[8px] bg-backgroundButton hover:bg-backgroundButtonHovered cursor-pointer"
                    onClick={() => setIsVisible(true)}
                >
                    <DeleteTrashIconSVG className="mr-2.5 dmax2:mr-1 w-6 dmax2:w-5 h-6 dmax2:h-5 text-textWhite" />
                    <span className="H16 dmax2:H14 text-white dmin2:pb-[2px] dmax2:pt-[2px]">
                        {t("work.deleteWork")}
                    </span>
                </div>
            }
        >
            <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[340px] ti6:max-w-[340px] ti7:max-w-[280px] tmax4:max-w-[280px] break-words">
                {t("work.deletionAssurance")}
            </p>
        </CustomPopup>
    );
};

export default DeleteWork;
